import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getGameById } from "../api/game";
import { setGroup } from "../redux/actions";
import { ROUTES } from "../utils/constants";
import { updateStats } from "../utils/helpers";
import "./StartGame.css";
import "./SessionEndPages.css";

/**
 * Pantalla cuando los escenarios 3+ están desactivados (revisión médica pendiente).
 */
export default function ScenariosDevLockScreen() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const group = useSelector((state) => state.group);
	const game = useSelector((state) => state.game);
	const [loading, setLoading] = useState(false);

	const finishToResults = async (e) => {
		e.preventDefault();
		if (loading) return;
		setLoading(true);
		if (group) {
			const merged = {
				...group,
				lastVisited: ROUTES.RESULTS,
				finished: true,
			};
			dispatch(setGroup(merged));
			updateStats(merged);
		}
		try {
			const res = await getGameById(game?._id);
			if (res?.status === 200) {
				navigate(ROUTES.RESULTS);
				return;
			}
		} catch {
			/* continuar igual */
		}
		navigate(ROUTES.RESULTS);
	};

	return (
		<div className="start-game-page session-end-page session-end-page--notice">
			<div className="start-game-inner start-game-inner--prep5 session-end-inner">
				<span className="start-game-badge sg5-badge">
					<span className="start-game-badge-dot" aria-hidden />
					Juego en curso
				</span>

				<div className="sg5-scroll">
					<header className="sg5-hero">
						<h1 className="sg5-title">
							<span className="sg5-title-accent">En fase de desarrollo</span>
						</h1>
						<p className="sg5-lead session-end-lead">
							Los siguientes escenarios (estratificación y posteriores) aún no están disponibles en esta
							versión. Podéis cerrar aquí la partida y ver el resultado con lo completado hasta ahora.
						</p>
					</header>

					<div className="session-end-card">
						<p className="session-end-card__text mb-0">
							Cuando el contenido esté revisado y publicado, se reactivará el acceso al resto del caso.
						</p>
					</div>
				</div>

				<div className="sg5-actions">
					<button
						type="button"
						className="start-game-cta sg5-cta session-end-cta-wide"
						onClick={finishToResults}
						disabled={loading}
						aria-busy={loading}
					>
						{loading ? <span className="start-game-cta-spinner" aria-hidden /> : null}
						{loading ? "…" : "Terminar juego"}
					</button>
				</div>
			</div>
		</div>
	);
}
